import { render, staticRenderFns } from "./export-section.vue?vue&type=template&id=4fa86bee"
import script from "./export-section.vue?vue&type=script&lang=js"
export * from "./export-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports